module.exports = __webpack_public_path__ + "media/images/slider_h1_04-85124c8ca10821ced9dc93e0244a428e.png";